import { clsx } from 'clsx'
import { type FC } from 'react'

interface ProductFormattedUnitPriceProps {
  classNames?: string
  formattedUnitPrice: string
}

export const ProductFormattedUnitPrice: FC<ProductFormattedUnitPriceProps> = ({
  classNames,
  formattedUnitPrice,
}) => {
  return (
    <div
      className={clsx('text-dark-primary-medium', classNames)}
      data-qa-id="current-variant-price-per-unit"
    >
      {formattedUnitPrice}
    </div>
  )
}
